module.exports = __webpack_public_path__ + "static/img/counp2.3d371eba.png";